import { AnbAddressSearchParameterKeys } from '@anb/ng-address-search';
import { AnbKadasterParameterKeys } from '@anb/ng-kadaster';
import { AnbMapsUtilParameterKeys } from '@anb/ng-maps-util';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { Router } from '@angular/router';
import { AnbNgConfiguratieService } from '@anb/ng-configuratie';
import { AnbLoaderInterceptor, AnbErrorHandlerInterceptor, AnbLoaderConfig } from '@anb/ng-ui';
import { AppConstants } from '@shared/constants/app.constants';
import { ENVIRONMENT } from 'environments/environment';
import { CoreService } from './services/core.service';
import { RouteService } from './services/route.service';
import { AppConfigKeys, AppConfigs } from '@shared/constants/app.configurations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { Clients } from './api/clients';
import { API_BASE_URL } from './api/proxy';
import { AuthImports } from './auth/auth-config';

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ...AuthImports,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: AppConstants.defaultLanguage,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: API_BASE_URL, useValue: ENVIRONMENT.API_BASE_PATH },
    { provide: HTTP_INTERCEPTORS, useClass: AnbLoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AnbErrorHandlerInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: AnbNgConfiguratieService) => () => {
        const result = configService
          .getConfiguration$({
            basePath: ENVIRONMENT.configuratieServiceUri,
            keys: [...AppConfigKeys, ...AnbAddressSearchParameterKeys, ...AnbKadasterParameterKeys, ...AnbMapsUtilParameterKeys],
          })
          .toPromise()
          .then(() => {
            AppConstants.loaderConfig.exclude.push(configService.getValue(AppConfigs.GeoLocation) + '/v4/suggestion?q=');
          });
        return result;
      },
      deps: [AnbNgConfiguratieService],
      multi: true,
    },
    {
      provide: AnbLoaderConfig,
      useValue: AppConstants.loaderConfig,
      deps: [AnbNgConfiguratieService],
    },
    CoreService,
    RouteService,
    ...Clients,
  ],
  exports: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule, router: Router) {
    if (parentModule) {
      throw new Error('Import CoreModule only in AppModule');
    }
  }
}
